<h1 mat-dialog-title id="del-element-title">{{ title }}</h1>
<mat-dialog-content id="del-element-content">
  <div class="row">
    <div class="col-12 col-md-12" id="del-element-text">
      {{ text }}
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions id="del-element-actions">
  <div class="container-fluid">
    <div class="row d-flex justify-content-center align-items-center">
      <button id="del-element-btn-delete" class="btnOK" mat-button type="button" (click)="delete()">
        <em class="far fa-trash-alt"></em> <span i18n="@@js_Delete" style="margin-left: 8px;">Eliminar</span>
      </button>
      <button id="del-element-btn-cancel" class="btnCancel" mat-button type="button" mat-dialog-close i18n="@@cancel">Cancel</button>
    </div>
  </div>
</mat-dialog-actions>
